import { Controller } from "@hotwired/stimulus"

// Opens the « + Coffret » <dialog> instead of following the link (the link is the no-JS path).
// No optional chaining: Webpacker 5 does not transpile it.
export default class extends Controller {
  static targets = ["dialog"]

  // A button outside the dialog's own scope (the sold-out block's) names the dialog by
  // data-dialog-id.
  open(event) {
    var dialog = this.hasDialogTarget ? this.dialogTarget : document.getElementById(event.currentTarget.dataset.dialogId || "")
    if (!dialog || typeof dialog.showModal !== "function") return

    event.preventDefault()
    dialog.showModal()
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  // A click on the backdrop lands on the <dialog> element itself, never on its content.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
